import { register } from '../dispatcher';
import { ActionTypes } from '../constants/MogamboConstants';
import createStore from './StoreUtils.js';

const TemplateStore = createStore({
  _allTemplates: [],
  _currentTemplate: null,
  _templateData: {},

  setAllTemplates(allTemplates) {
    // Sort templates by Name probably
    this._allTemplates = allTemplates;
  },

  getAllTemplates() {
    return this._allTemplates;
  },

  setTemplateData(templateId, templateData) {
    this._currentTemplate = templateId;
    this._templateData = templateData;
  },

  getTemplateData() {
    return this._templateData;
  },
});

TemplateStore.dispatchToken = register(action => {
  const actionType = action.type;
  const payload = action.action;

  switch (actionType) {
    case ActionTypes.FETCH_TEMPLATES_SUCCESS:
      TemplateStore.setAllTemplates(payload.data);
      TemplateStore.emitChange();
      if (payload.callback) payload.callback();
      break;

    case ActionTypes.FETCH_TEMPLATE_DATA_SUCCESS:
      TemplateStore.setTemplateData(payload.id, payload.data);
      TemplateStore.emitChange();
      break;

    case ActionTypes.UPDATE_TEMPLATE_DATA:
      TemplateStore.setTemplateData(payload.templateId, payload.templateData);
      TemplateStore.emitChange();
      break;

    default:
      break;
  }
});

export default TemplateStore;
